import React, { useEffect, useState } from "react";
import useApp from "../../utils/useApp";
import { Button, Col, Container, Row, Spinner } from "react-bootstrap";
import { Case } from "../../types/case";
import CaseCard from "./CaseCard";
import { fetchNoteTypes } from "../../services/httpClient";
import ToastMsg from "../ui/ToastMsg";

interface CaseViewState {
  filteredMyCases: Case[];
  filteredOtherCases: Case[];
  caseStatus: string;
  loadingMore: boolean;
  otherCasesLoaded: number;
  addMoreCases: any;
  limitedAccess: boolean;
  caseFilter: string;
}

const CaseView = ({
  filteredMyCases,
  filteredOtherCases,
  caseStatus,
  loadingMore,
  otherCasesLoaded,
  addMoreCases,
  limitedAccess,
  caseFilter,
}: CaseViewState) => {
  const { auth, viewAllCases }: any = useApp();
  const [types, setTypes] = useState<any[]>([]);
  const [showToast, setShowToast] = useState<boolean>(false);
  const [toastBody, setToastBody] = useState<string>("");
  const [toastText, setToastText] = useState<string>("");

  useEffect(() => {
    getTypes();
  }, [auth?.profile]);

  const getTypes = () => {
    fetchNoteTypes()
      .then((res: any) => {
        var types = res[0].data.filter((n: any) => n?.type !== "system");
        types = types.filter((t: any) => t?.is_published === 1);
        types = types.filter((n: any) => n?.is_archived !== 1);

        var sorted = [...types];
        sorted.sort((a: any, b: any) => a.is_archived - b.is_archived);

        setTypes(sorted);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  return (
    <>
      <ToastMsg showToast={showToast} setShowToast={setShowToast} toastText={toastText} toastBody={toastBody} />

      {viewAllCases && filteredOtherCases.length > 0 && (
        <>
          <Row>
            <Col xs={12}>
              <h4 className="hero-heading app-header-text"> {"Other Cases (" + filteredOtherCases.length + ")"}</h4>
            </Col>
          </Row>
          <Row className="justify-content-center mb-3">
            <Container className="card-container">
              {filteredOtherCases.slice(0, otherCasesLoaded).map((c: any) => (
                <CaseCard
                  key={c.id}
                  myCase={c}
                  caseStatus={caseStatus}
                  types={types}
                  setShowToast={setShowToast}
                  setToastText={setToastText}
                  setToastBody={setToastBody}
                  limitedAccess={limitedAccess}
                  caseFilter={caseFilter}
                />
              ))}
            </Container>
          </Row>
        </>
      )}
      {(otherCasesLoaded >= filteredOtherCases.length || !viewAllCases) && (
        <>
          {viewAllCases && filteredMyCases.length > 0 && (
            <Row>
              <Col xs={12}>
                <h4 className="hero-heading app-header-text"> {"My Cases (" + filteredMyCases.length + ")"}</h4>
              </Col>
            </Row>
          )}

          <Row className="justify-content-center mb-5 pb-5">
            <Container className="card-container">
              {filteredMyCases.map((c: any, index: number) => (
                <CaseCard
                  key={c.id}
                  firstMyCase={index === 0}
                  myCase={c}
                  caseFilter={caseFilter}
                  caseStatus={caseStatus}
                  types={types}
                  setShowToast={setShowToast}
                  setToastText={setToastText}
                  setToastBody={setToastBody}
                  limitedAccess={limitedAccess}
                />
              ))}
              {filteredOtherCases.length === 0 && filteredMyCases.length === 0 && <p className="mt-2">No Case Records</p>}
              {!viewAllCases && filteredMyCases.length === 0 && filteredOtherCases.length > 0 && <p className="mt-2">No Case Records</p>}
            </Container>
          </Row>
        </>
      )}
      {loadingMore ? (
        <Button size="sm" className="spinner-button spinner-button-main">
          <Spinner animation="border" style={{ color: "#F6893D" }} />
        </Button>
      ) : (
        // Show "Load More" button if there are more cases to load
        // IE: Viewing all cases, and the filtered cases length is greater than loaded cases (are there more cases to load from search)
        viewAllCases &&
        filteredOtherCases.length > otherCasesLoaded && (
          <Row className="justify-content-center">
            <Col xs="auto">
              <Button className="app-primary-color button mb-5" onClick={() => addMoreCases()}>
                Load More
              </Button>
            </Col>
          </Row>
        )
      )}
    </>
  );
};

export default CaseView;
